import React from 'react';
import usePersistedTab from '../hooks/usePersistedTab';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { ConfirmationNumber } from '@mui/icons-material';
import CasinoPromoTab from './promo/CasinoPromoTab';
import LunarStartTab from './promo/LunarStartTab';

/**
 * 🎟️ Страница «Промокоды»: две вкладки.
 *  1 (default) — «Слоты/Казино»: универсальные промики (награды-бандлы).
 *  2 — «Лунный марафон»: акция Lunar Start (как была, без изменений).
 */
function Promo() {
  const [tab, setTab] = usePersistedTab('promo', 0);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <ConfirmationNumber sx={{ color: '#26a17b' }} />
        <Typography variant="h4">Промокоды</Typography>
      </Box>
      <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 3 }}>
        <Tab label="🎰 Слоты/Казино" />
        <Tab label="🌙 Лунный марафон" />
      </Tabs>
      {tab === 0 ? <CasinoPromoTab /> : <LunarStartTab />}
    </Box>
  );
}

export default Promo;
